import { render, staticRenderFns } from "./preTestResult.vue?vue&type=template&id=d4ab1c98&"
import script from "./preTestResult.vue?vue&type=script&lang=js&"
export * from "./preTestResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports